import { render, staticRenderFns } from "./index.vue?vue&type=template&id=437e89a9&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=437e89a9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "437e89a9",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/tariff/index.vue
// module id = null
// module chunks = 